import { render, staticRenderFns } from "./ParametreSmsSuccess.vue?vue&type=template&id=5ef14d22&scoped=true"
import script from "./ParametreSmsSuccess.vue?vue&type=script&lang=js"
export * from "./ParametreSmsSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ef14d22",
  null
  
)

export default component.exports